import { Icon } from "@iconify/react";
import { useEffect, useState } from "react";

export default function SearchBox({
   defaultValue = "",
   placeholder = "Search ...",
   onSearch,
   className = "",
}: {
   defaultValue?: string;
   placeholder?: string;
   onSearch: (value: string) => void;
   className?: string;
}) {
   const [value, setValue] = useState(defaultValue);

   useEffect(() => {
      setValue(defaultValue);
   }, [defaultValue]);

   const submit = () => onSearch(value.trim());
   const clear = () => {
      setValue("");
      onSearch("");
   };

   return (
      <div className={`flex items-center gap-1 flex-1 ${className}`}>
         <input
            type="search"
            placeholder={placeholder}
            value={value}
            onChange={(e) => setValue(e.target.value)}
            onKeyDown={(e) => {
               if (e.key === "Enter") {
                  e.preventDefault();
                  submit();
               }
            }}
            className="flex-1 px-3 py-2 border rounded-lg w-full outline-1 outline-slate-400"
         />
         {value && (
            <button
               type="button"
               onClick={clear}
               className="px-2 py-2 border rounded text-slate-500 hover:bg-slate-100"
               title="Clear"
            >
               <Icon icon="material-symbols:close" width={18} height={18} />
            </button>
         )}
         <button
            type="button"
            onClick={submit}
            className="px-2 py-2 border rounded bg-slate-100 hover:bg-slate-200 flex items-center gap-1"
            title="Search"
         >
            <Icon icon="material-symbols:search" width={18} height={18} />
         </button>
      </div>
   );
}
